import { render } from "./AppSidebar.vue?vue&type=template&id=36939114&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=36939114&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=1&id=36939114&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=2&id=36939114&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36939114"]])

export default __exports__